import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import noop from 'lodash/noop';

import { saveForecast } from '../../actions/forecast';
import { loadTorneoEstado } from '../../actions/torneo';
import Bracket from '@layout/BracketLayout';
import { isWordCupStarted } from '@selectors/clock';
import Announcement from '@views/Announcement';
import PageMenu from '@views/PageMenu';
import Groups from '@views/Groups';
import TodayMatches from '@views/TodayMatches';

import './Matches.css';
import Link from 'redux-first-router-link';

export const Matches = (props) => {
  React.useEffect(() => {
    props.loadTorneoEstado();
  }, []);

  return (
    <div className="Matches forecast">
      <Announcement />
      <div className="hero-bg">
        <div className="hero-content">
          <div>
            <h2>Prode 2026</h2>
            <p>
              Completá tu pronóstico para cada uno de los partidos. Tenés tiempo
              hasta el 10 de Junio para hacer todos los cambios que quieras.
            </p>
            <TodayMatches matches={props.todayMatches} />
          </div>
        </div>
        <PageMenu onAction={props.onAction} />
      </div>
      <div className="matches-container">
        <Groups />
        <Bracket />
      </div>
    </div>
  );
};

Matches.displayName = 'Matches';
Matches.propTypes = {
  onAction: PropTypes.func,
  worldCupStarted: PropTypes.bool,
  loadTorneoEstado: PropTypes.func,
};
Matches.defaultProps = {
  onAction: noop,
  loadTorneoEstado: noop,
};

export const mapStateToProps = (state) => ({
  worldCupStarted: isWordCupStarted(state),
});

export const mapDispatchToProps = (dispatch) => ({
  onAction: () => dispatch(saveForecast()),
  loadTorneoEstado: () => dispatch(loadTorneoEstado()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Matches);
